import { useEditor } from '@craftjs/core';
import RedoIcon from '@mui/icons-material/Redo';
import UndoIcon from '@mui/icons-material/Undo';
import { Box, Divider, IconButton } from '@mui/material';
import React, { useContext } from 'react';
import { CanvasContext } from './CanvasContext';
import CanvasSize from './CanvasSize';
import ThemeSelection from './ThemeSelection';

const ActionsBar: React.FC = () => {
	const { actions, canUndo, canRedo } = useEditor((_state, query) => ({
		canUndo: query.history.canUndo(),
		canRedo: query.history.canRedo()
	}));

	// we are using context as a workaround
	// because the header component is injected from outside and currently contains both flow editor logic and page editor logic
	// and the effort to refactor it was too big
	const { theme, setTheme, setWidth, setHeight, width, height } =
		useContext(CanvasContext);

	return (
		<Box
			color="transparent"
			style={{ padding: 10, zIndex: 2 }}
			data-testid="page-editor-top-bar"
			display="flex"
			gap={1}
		>
			<CanvasSize
				setWidth={setWidth!}
				setHeight={setHeight!}
				width={width!}
				height={height!}
			/>

			<Divider orientation="vertical" flexItem />
			<ThemeSelection theme={theme} setTheme={setTheme!} />

			<Divider orientation="vertical" flexItem />

			<Box display="flex">
				<IconButton
					disabled={!canUndo}
					onClick={actions.history.undo}
					title={intl.tr('button.undo')}
					data-testid="page-editor-undo"
				>
					<UndoIcon color={canUndo ? 'primary' : 'disabled'} />
				</IconButton>
				<IconButton
					disabled={!canRedo}
					onClick={actions.history.redo}
					title={intl.tr('button.redo')}
					data-testid="page-editor-redo"
				>
					<RedoIcon color={canRedo ? 'primary' : 'disabled'} />
				</IconButton>
			</Box>
		</Box>
	);
};

export default ActionsBar;
